export default __webpack_public_path__ + "static/crimepunishment-47e1fc3e21755879d06f35fc34623323.jpg";